<div class="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
    <app-header></app-header>
    <div class="app-main">
        <!-- Menu Section --->
        <app-menus></app-menus>
        <!-- Menu section End -->
        <div class="app-main__outer">
            <div class="app-main__inner">
                <div class="app-page-title">
                    <div class="page-title-wrapper">
                        <div class="page-title-heading">
                            <div class="page-title-icon">
                                <i class="pe-7s-notebook icon-gradient bg-mixed-hopes"></i>
                            </div>
                            <div>
                                Spare Part Details <div class="page-title-subheading"> SO Number (Project Name): {{project_no}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ------ -->
                <!-- new code - mobile frinedly -->
                <div [hidden]="!sparePartsResultDataExist" class="row">
                    <div class="main-card card mb-3 w-100">
                        <div class="row ml-1 mr-1">
                            <!-- Project Details -->
                            <div class="col-md-4 col-12">
                                <table class="table table-bordered table-striped mt-3">
                                    <tbody>
                                        <tr>
                                            <th style="width: 200px;">SO Number (Project Name)</th>
                                            <td>{{ project_no }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- Download Button -->
                            <div class="col-md-4 col-12 d-flex align-items-center justify-content-md-start justify-content-center">
                                <button type="button" class="btn btn-primary">
                                    <a href="{{ url }}" target="_blank" style="color: white; text-decoration: none;">Download</a>
                                </button>
                            </div>
                
                            <!-- Email Form -->
                            <form [formGroup]="proposalFrm" class="col-md-4 col-12">
                                <div class="row ">
                                    <div class="col-md-8 col-12 mt-3 ">
                                        <div class="form-group">
                                            <input
                                                id="emailId"
                                                placeholder="Enter E-Mail"
                                                type="text"
                                                required
                                                formControlName="emailId"
                                                class="form-control"
                                            />
                                            <!-- <div class="alert alert-danger mt-2" *ngIf="proposalFrm.invalid && proposalFrm.get('emailId').errors">
                                                <div *ngIf="proposalFrm.get('emailId').hasError('required')">
                                                    Email is Required
                                                </div>
                                                <div *ngIf="proposalFrm.get('emailId').hasError('pattern')">
                                                    Please enter a valid email address
                                                </div>
                                            </div> -->
                                            <span class="text-danger mt-2" *ngIf="proposalFrm.get('emailId').invalid && (proposalFrm.get('emailId').touched || proposalFrm.get('emailId').dirty)">
                                                <span *ngIf="proposalFrm.get('emailId').hasError('required')">
                                                    E-Mail Is Required.
                                                </span>
                                                <span *ngIf="proposalFrm.get('emailId').hasError('pattern')">
                                                    E-Mail is not a valid e-mail address.
                                                </span>
                                            </span>
                                        
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-12 d-flex align-items-center justify-content-md-start justify-content-center">
                                        <button
                                            class="btn btn-primary"
                                            name="submit"
                                            type="submit"
                                            (click)="onSubmit()"
                                            [disabled]="submitted"
                                        >
                                            Send E-Mail
                                        </button>
                                    </div>                                     
                                </div>                                
                            </form>
                
                            <!-- Price Validity -->
                            <div class="col-12 mt-4">
                                <h3 class="text-center">{{ priceValidityTill }}</h3>
                            </div>
                
                            <!-- Table -->
                            <div class="col-12 mt-4">
                                
                                <div class="table-responsive">
                                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-bordered table-striped custom-datatable">
                                        <thead>
                                            <tr class="text-center">
                                                <th>Sr.No.</th>
                                                <th>Item Code</th>
                                                <th>Item Name</th>
                                                <th>Sub Assembly</th>
                                                <th>Sub Assembly Name</th>
                                                <th>Qty used In/MC</th>
                                                <th>Spare Category</th>
                                                <th>Unit</th>
                                                <th>Unit Price</th>
                                                <th>Total Cost</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="text-center" *ngFor="let user of users; let i = index">
                                                <td>{{ i + 1 }}</td>
                                                <td>{{ user.itemCode }}</td>
                                                <td>{{ user.itemName }}</td>
                                                <td>{{ user.subAssembly }}</td>
                                                <td>{{ user.subAssemblyName }}</td>
                                                <td>{{ user.QtyusedInMC }}</td>
                                                <td>{{ user.SpareCategory }}</td>
                                                <td>{{ user.unit }}</td>
                                                <td>{{ user.currency ? user?.currency + ' ' + (user.price || 0) : (user.price || 0) }}</td>
                                                <td>{{ user.currency ? user?.currency + ' ' + (user.price * user.QtyusedInMC).toFixed(2) : (user.price * user.QtyusedInMC).toFixed(2) }}</td>                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!sparePartsResultDataExist" class="row">
                    <div class="col-md-12">
                        <div class="main-card mb-3 card">
                            <div class="card-body text-center">
                                <div>Spare Part Details For The Selected Project Not Yet Published!</div>
                            </div>
                        </div>
                    </div>
                </div>
                 <!-- new code - end -->
            </div>
        </div>
    </div>
</div>